import React, { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { SimpleCollapse, ErrorBoundary } from 'components'
import { useToggle } from 'hooks'
import { IHandleChangeRowsPerPage, IHandleChangePage } from 'hooks/useGet'
import { useForm, FormProvider } from 'react-hook-form'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import {
  IGetAllSubItensResponse,
  IGetAllSubItensParams
} from 'services/GST/CadastroItensSubitensSeguranca'
import * as yup from 'yup'

import { useSecurityItensAndSubItens } from '../../../../context'
import Form from './components/Form'
import TableSubItens from './components/TableSubItens'
import { IFormAddSubItem } from './types'

interface ISecuritySubItemProps {
  data: IPaginatedEntityGST<IGetAllSubItensResponse[]>
  refresh: (_params: IGetAllSubItensParams) => void
  page: number
  rowsPerPage: number
  handleChangePage: IHandleChangePage
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
}

const SCHEMA = yup.object({
  idInfracaoSubItemSeguranca: yup.number().typeError('Campo obrigatório.').required('Campo obrigatório.'),
  nmSubItemSeguranca: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.'),
  txSubItemDescricao: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.')
})

const SecuritySubItem: React.FC<ISecuritySubItemProps> = ({
  data,
  refresh,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  const methods = useForm<IFormAddSubItem>({
    resolver: yupResolver(SCHEMA)
  })
  const { selectedItem } = useSecurityItensAndSubItens()
  const [isExpanded, setIsExpanded] = useState(true)

  useEffect(() => {
    refresh({
      idItemSeguranca: selectedItem?.idItemSeguranca
    })

    setIsExpanded(() => false)
  }, [selectedItem])

  return (
    <FormProvider {...methods}>
      <SimpleCollapse
        isOpen={isExpanded}
        setIsOpen={setIsExpanded}
        title={`CADASTRO DE SUBITEM DE SEGURANÇA - ${selectedItem?.nmItemSeguranca}`}
      >
        <>
          <Form refresh={refresh} />
          <ErrorBoundary>
            <TableSubItens
              data={data}
              refresh={refresh}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleChangePage={handleChangePage}
            />
          </ErrorBoundary>
        </>
      </SimpleCollapse>
    </FormProvider>
  )
}

export default SecuritySubItem
